import eventListeners from './event-listeners';
import documentClickHandler from '../handlers/document-click-handler';

const clickListener = (element) => {
  eventListeners.add(element, 'click', documentClickHandler, true);
};

export default clickListener;
